import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=18498b00&"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/philippneumann/Documents/frontendstudios/8291/495/GonserDT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18498b00')) {
      api.createRecord('18498b00', component.options)
    } else {
      api.reload('18498b00', component.options)
    }
    module.hot.accept("./DesktopNavigation.vue?vue&type=template&id=18498b00&", function () {
      api.rerender('18498b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/DesktopNavigation.vue"
export default component.exports